/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

function setStyle(el, styles) {
  var keys = Object.keys(styles);
  keys.forEach(function (key) {
    el.style[key] = styles[key];
  });
}

export { setStyle as default };
//# sourceMappingURL=set-style.mjs.map
